import React, { Component } from "react";
import { Form, Col, Row, Button } from "react-bootstrap";
import imgCamelLogo from '../../assets/images/main-logo-white.png';
import { addEventNameToEndpoint } from '../../utils/common';
import "./AddContentItemForm.scss";

class AddContentItemForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditing: false,
      contentName: '',
      stage: 1,
      description: ''
    }
  }

  componentDidMount() {
    if (this.props.values) {
      this.setState({
        contentName: this.props.contentName,
        stage: this.getStageByType(),
        description: this.props.values.description,
        isEditing: true
      });
    }
  }

  onChangeValue = (type, value) => {
    this.setState({ [type]: value });
  }

  onSubmit = (e) => {
    e.preventDefault();

    addEventNameToEndpoint(this.props.Analytics, this.state.isEditing ? 'admin-funnelStage-edit' : 'admin-funnelStage-add');
    
    this.props.onAddContent({
      originalName: this.state.isEditing ? this.props.contentName : null,
      name: this.state.contentName,
      stage: this.state.stage,
      description: this.state.description
    });

    this.props.onClose();
  }

  getStageByType = () => {
    switch (this.props.type) {
      case 'funnel':
        return this.props.values.stage;
      case 'product':
      case 'industry':
      case 'type':
      case 'region':
        return this.props.values.sort;
      default:
        return this.props.values.stage;
    }
  }

  getNamePlaceholder = () => {
    switch (this.props.type) {
      case 'funnel':
        return 'Funnel stage name';
      case 'product':
        return 'Product name';
      case 'industry':
        return 'Industry name';
      case 'region':
        return 'Region name';
      case 'type':
        return 'Content type name'
      default:
        return 'Funnel stage name';
    }
  }

  renderHeaderText = () => {
    const { isEditing } = this.state;
    switch (this.props.type) {
      case 'funnel':
        return <h3>{isEditing ? "Edit Funnel Stage" : "Add Funnel Stage"}</h3>;
      case 'product':
        return <h3>{isEditing ? "Edit Product" : "Add Product"}</h3>;
      case 'industry':
        return <h3>{isEditing ? "Edit Industry" : "Add Industry"}</h3>;
      case 'region':
        return <h3>{isEditing ? "Edit Region" : "Add Region"}</h3>;
      case 'type':
        return <h3>{isEditing ? "Edit Content Type" : "Add Content Type"}</h3>;
      default:
        return <h3>{isEditing ? "Edit Funnel Stage" : "Add Funnel Stage"}</h3>
    }
  }

  render() {
    const {
      contentName,
      stage,
      description,
      isEditing
    } = this.state;

    return (
      <Form className="add-content-item-form" onSubmit={this.onSubmit}>
        <div className="form-header">
          <img src={imgCamelLogo} alt="logo" />
        </div>
        <div className="p-4">
          {this.renderHeaderText()}
          <Form.Group as={Row} >
            <Col sm="6">
              <Form.Control
                id="itemName"
                type="text"
                className="mr-4"
                placeholder={this.getNamePlaceholder()}
                value={contentName}
                onChange={(e) => this.onChangeValue('contentName', e.target.value)}
                required
              />
            </Col>
            <Col sm="3">
              <Form.Control
                id="stage"
                type="text"
                placeholder="Stage"
                value={stage}
                onChange={(e) => this.onChangeValue('stage', e.target.value)}
                required
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="contentDescription">
            <Col sm="12">
              <Form.Control
                as="textarea"
                rows="4"
                placeholder="Description..."
                value={description}
                onChange={(e) => this.onChangeValue('description', e.target.value)}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="actionsContainer" >
            <Col className="d-flex justify-content-end actions-container">
              <Button variant="outline-danger" className="mr-2" size="sm" onClick={this.props.onClose}>CANCEL</Button>
              <Button
                type="submit"
                variant="outline-danger"
                size="sm"
                data-cc-analytics-on='click'
                id={isEditing ? 'btnEditFunnelStage' : 'btnAddFunnelStage'}
                data-cc-analytics-name={isEditing ? 'admin-funnelStage-edit' : 'admin-funnelStage-add'}
                data-cc-analytics-attrs={`contentName:${contentName}`}
              >
                SAVE
              </Button>
            </Col>
          </Form.Group>
        </div>
      </Form>
    )
  }
}

export default AddContentItemForm;
